const counts = [
    {id:1,icon:'bi bi-emoji-smile',title:'Average Package',description:'7.91'},
    {id:2,icon:'bi bi-journal-richtext',title:'Compines Visited',description:'119'},
    {id:3,icon:'bi bi-headset',title:'Student Placed',description:'659'},
    {id:4,icon:'bi bi-people',title:'Heighest Package',description:'43.65'},
  ];
  
export default counts;